import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { logoutUser } from "../global/GlobalFunctions";
import { linkWhatsapp, linkTestGratis, linkYoutube, linkInstagram } from "../global/GlobalVariables";
import supportLogo from "../assets/svg/headset-dark-mode.svg";
export default function HeaderAccountFree(props) {
  const { statusMode } = props;
  const handleVoltarClick = () => {
    logoutUser().then(()=>{
      window.location.href = "/";
    });
    
  };

  const wpplogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-whatsapp-96.png`;
  const instalogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-instagram-96.png`;
  const youtlogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-reproduzir-youtube-96.png`;
  const logobranca = `${process.env.PUBLIC_URL}/LOGOBRANCO.png`;

  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className={`bg-body-tertiary header d-flex justify-content-between align-items-center navbar navbar-expand-lg navbar-dark ResponsivHeader ${
            statusMode ? "dark-mode" : ""
          }`}
        >
          <Container fluid>
            <Navbar.Brand href="#">
              <div className=" p-2 fw-semibold d-flex align-items-center">
                <a
                  className={`text-decoration-none fs-5 me-3 ${
                    statusMode ? "textDark" : "text-light"
                  }`}
                  href="/"
                >
                  <img
                    src={logobranca}
                    alt="Logo"
                    style={{ height: "55px", width: "auto" }}
                    className="imgfullhd"
                  />
                </a>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
              className="margin20px"
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <a
                    className={`text-decoration-none fs-5 me-3 ${
                      statusMode ? "textDark" : "text-light"
                    }`}
                    href="/"
                  >
                    <img
                      src={logobranca}
                      alt="Logo"
                      style={{ height: "55px", width: "auto" }}
                      className="imgfullhd"
                    />
                  </a>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="social">
                  <a
                    href={linkInstagram}
                    target="_blank"
                    rel="noreferrer"
                    className="social-link"
                  >
                    <img
                      src={instalogo}
                      alt="Instagram"
                      className="social-icon insta"
                    />
                  </a>
                  <div className="space-icon"></div>
                  <a
                    href={linkYoutube}
                    target="_blank"
                    rel="noreferrer"
                    className="social-link"
                  >
                    <img
                      src={youtlogo}
                      alt="YouTube"
                      className="social-icon youtube"
                    />
                  </a>
                  <div className="space-icon"></div>
                  <a
                    href={linkWhatsapp}
                    target="_blank"
                    rel="noreferrer"
                    className="social-link"
                  >
                    <img src={supportLogo} alt="Suporte" className="social-icon" />
                  </a>
                </div>
                <div className="menu mudanca-menu">
                  <ul className={`menu-links text-light `}>
                    <a
                      href={linkTestGratis}
                      target="_blank"
                      rel="noreferrer"
                      className="linknavbar"
                    >
                      <li className="nav-link">
                        <span className="navlink">
                          <a className="linknavbar">
                            <b className={` text-light `}>Acesse a comunidade</b>
                          </a>
                        </span>
                      </li>
                    </a>
                  </ul>

                  <button onClick={handleVoltarClick}>
                    <ul className={`menu-links text-light `}>
                      <li className="nav-link">
                        <span className="navlink">
                          <a className="linknavbar">
                            <b className={` text-light `}>SAIR</b>
                          </a>
                        </span>
                      </li>
                    </ul>
                  </button>
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}
